<app-page-header [title]="'Rechten'" subtitle="matrix">
    <div class="pr-3" indicator>
        <input [(ngModel)]="search" matInput placeholder="Zoeken" />
    </div>
</app-page-header>
<mat-tab-group>
    <mat-tab label="Rollen">
        @if (roles?.length && functionalities?.length) {
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th
                            class="feature feature-name clickable-key"
                            (click)="toggleHighlightedRolesVisibility()"
                            title="Klik om alleen gemarkeerde rollen te tonen/verbergen">
                            <b>Key</b>
                        </th>
                        @for (role of roles; track role) {
                            @if (shouldShowRole(role)) {
                                <th [class.highlighted-column]="isRoleHighlighted(role)">
                                    <div
                                        class="role-name"
                                        [class.highlighted-role-name]="isRoleHighlighted(role)"
                                        (contextmenu)="toggleRoleHighlight($event, role)"
                                        title="Rechtsklik om te markeren">
                                        @if (role.is_unique) {
                                            <i class="fas fa-star ml-1"></i>
                                        }
                                        {{ role.name }}
                                    </div>
                                </th>
                            }
                        }
                        <th class="after"></th>
                    </tr>
                </thead>
                @for (functionality of functionalities | search: 'name' : search; track functionality) {
                    <tr>
                        <th class="feature feature-side">
                            {{ functionality.name }}
                        </th>
                        @for (role of roles; track role) {
                            @if (shouldShowRole(role)) {
                                <td
                                    class="checkox-td"
                                    [class.highlighted-column]="isRoleHighlighted(role)"
                                    title="{{ role.name }}">
                                    <input
                                        [checked]="role | roleHasFunctionality: functionality"
                                        [disabled]="disabled"
                                        (change)="checkFunctionality($event, functionality, role)"
                                        type="checkbox" />
                                </td>
                            }
                        }
                        <th class="after">
                            {{ functionality.key }}
                        </th>
                    </tr>
                }
            </table>
        }
    </mat-tab>
    <mat-tab label="Functionaliteiten">
        @if (functionalities?.length && features?.length) {
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th class="feature feature-name">
                            <b>Key</b>
                        </th>
                        @for (functionality of functionalities | search: 'name' : search; track functionality) {
                            <th>
                                <div class="role-name">
                                    {{ functionality.name }}
                                </div>
                            </th>
                        }
                        <th class="after"></th>
                    </tr>
                </thead>
                @for (feature of features; track feature) {
                    <tr>
                        <th class="feature feature-side">
                            {{ feature.name }}
                        </th>
                        @for (functionality of functionalities | search: 'name' : search; track functionality) {
                            <td class="checkox-td" title="{{ functionality.name }}">
                                <input
                                    [checked]="functionality | functionalityHasFeature: feature"
                                    [disabled]="disabled"
                                    (change)="checkFeature($event, functionality, feature)"
                                    type="checkbox" />
                            </td>
                        }
                        <th class="after">
                            {{ feature.key }}
                        </th>
                    </tr>
                }
            </table>
        }
    </mat-tab>
</mat-tab-group>
